import Tagify from '@yaireo/tagify';
document.addEventListener("DOMContentLoaded",function() {
    this.inputElements = document.querySelectorAll('.tags-search');

    this.inputElements && this.inputElements.forEach((tagSearch)=>{
        let searchTagify = new Tagify(tagSearch, {
            editTags: false,
            originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join('%20')
        });

        searchTagify.on('input', onInput)
                    .on('add', afterAdd)
                    .on('remove', afterRemove)

        function onInput() {
            searchTagify.DOM.input.setAttribute('data-placeholder', '');
        }

        function afterAdd() {
            searchTagify.DOM.input.setAttribute('data-placeholder', 'Type to add more');
        }

        function afterRemove() {
            if(searchTagify.getTagElms().length === 0) {
                searchTagify.DOM.input.setAttribute('data-placeholder', 'Start your search');
            } else {
                searchTagify.DOM.input.setAttribute('data-placeholder', 'Type to add more');
            }
        }

        if(document.getElementById('search-tags-container')) {
            let searchValues = document.getElementById('search-tags-container').value;
            if(searchValues) {
                searchTagify.addTags(searchValues.split('%20'))
            }
        }
    })
});